@if (isEpcotEnabled) {
    <ms-scroll-adapter [scrollSize]="scrollSize" [scrollItems]="filteredItems" (select)="onScrolled()">
        <div class="main-items" [class.scrolled-pills]="scrolled() && isEpcotEnabled">
            <div class="main-items-epcot">
                @for (item of filteredItems; track item.name) {
                    <div class="pill-style">
                        <a
                            vnMenuItemAction
                            vnMenuItemTracking
                            ds-pill
                            msThemedPills
                            [vnSpeculativeLink]="item.url"
                            [item]="item"
                            [origin]="tracking.NavTop"
                            [themedInverse]="themeInverseIndicator"
                            [selected]="isActive(tracking.NavTop, item.name)"
                            [size]="'medium'"
                            [attr.title]="item.toolTip"
                            (click)="itemClick($event, item)">
                            @if (item.class) {
                                <vn-icon slot="start" size="16" [name]="item.class" />
                            }

                            <span>{{ item.text }}</span>
                            <ds-notification-bubble vnMenuItemBadge section="{{ tracking.NavTop }}" item="{{ item.name }}"></ds-notification-bubble>
                        </a>

                        @if (item.parameters.tooltip === 'true') {
                            @if (item.toolTip) {
                                <span [ngClass]="item.parameters.tooltipClass" [innerHtml]="item.toolTip"></span>
                            }
                        }
                    </div>
                }
            </div>
        </div>
    </ms-scroll-adapter>
} @else {
    <div class="main-items">
        @for (item of filteredItems; track item.name) {
            <vn-menu-item
                badgeClass="badge-size-sm badge-offset"
                badgePosition="icon"
                linkClass="top-nav-link"
                textClass="text-truncate ui-icon-text"
                iconClass="{{ item.isSpecial ? 'special' : '' }} sports-icon ui-icon ui-icon-size-lg"
                [item]="item"
                [vnSpeculativeLink]="item.url"
                [section]="tracking.NavTop"
                [displayMode]="MenuDisplayMode.Icon"
                [ngClass]="{ 'before-separator': item.hasSeparator }"
                [class.active]="isActive(tracking.NavTop, item.name)"
                (click)="itemClick($event, item)" />
        }
    </div>
}
